/* eslint no-undef: 0 */
import {toQueryString} from '@s-ui/js/lib/string'

import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import DealerErrorsFactory from '../Errors/factory.js'
import DealerMappersFactory from '../Mappers/factory.js'
import DealerValueObjectsFactory from '../ValueObjects/factory.js'
import {EmptyDealerRepository} from './EmptyDealerRepository.js'
import {HTTPDealerRepository} from './HTTPDealerRepository.js'
import {SessionStorageDealerRepository} from './SessionStorageDealerRepository.js'

export default class DealerRepositoriesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @property {Config} config
   * @property {Fetcher} fetcher
   * @property {Fetcher} fetchOrFail
   * @return {HTTPDealerRepository}
   */
  static hTTPDealerRepository = ({config}) =>
    new HTTPDealerRepository({
      config,
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      fromDealerRawDataToDealerEntityMapper: DealerMappersFactory.fromDealerRawDataToDealerEntityMapper({config}),
      fromDealersListRawDataToDealersListValueObjectMapper:
        DealerMappersFactory.fromDealersListRawDataToDealersListValueObjectMapper({config}),
      contactDealerErrorFactory: DealerErrorsFactory.contactDealerError,
      resultValueObjectFactory: DealerValueObjectsFactory.resultValueObject,
      trackingPhoneDealerValueObjectFactory: DealerValueObjectsFactory.trackingPhoneDealerValueObject,
      trackingPhoneErrorFactory: DealerErrorsFactory.trackingPhoneError,
      getDealerErrorFactory: DealerErrorsFactory.getDealerError,
      searchResultsDealerErrorFactory: DealerErrorsFactory.searchResultsDealerError,
      callMeNowDealerErrorFactory: DealerErrorsFactory.callMeNowDealerError,
      toQueryString
    })

  static sessionStorageDealerRepository = ({config}) => new SessionStorageDealerRepository({config})

  static emptyDealerRepository = ({config}) => new EmptyDealerRepository({config})
}
